import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { Department, DepartmentDataService, ImportResult } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { createProvince } from "./client-province.service";

export interface DepartmentOptions extends ControllerOptions<Department> {
    province?: string;
    shortName?: string;
}

export const initDepartment = (): Department => createDepartment({});

export const createDepartment = (item: Partial<Department>): Department => ({
    id: item.id ?? "",
    name: item.name ?? "",
    code: item.code ?? "",
    shortName: item.shortName ?? "",
    province: item.province ?? createProvince({}),
    createdBy: item.createdBy ?? ""
});

export class ClientDepartmentService extends BaseClientService implements DataController<Department> {
    private _service: DepartmentDataService;

    constructor() {
        super();
        this._service = new DepartmentDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async getByShortName(options: DepartmentOptions): Promise<Department | null> {
        let result = await this._service.get({limit: 1, skip: 0, orderBy: "shortName"}, this.token, options.shortName);
        let item = result.data.find(x => x.shortName === options.shortName)
        if (item) return item;
        return null;

    }

    public async get(options: DepartmentOptions): Promise<ResultData<Department>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.province);
    }

    public async getLookup(options: DepartmentOptions): Promise<ResultData<Department>> {
        return await this._service.get(this.buildLookupFetchParams(options), this.token, options.filter);
    }

    public async getById(options: DepartmentOptions): Promise<Department | null> {
        return options.id ? await this._service.getById(options.id, this.token) : null;
    }

    public async delete(options: DepartmentOptions): Promise<void> {
        if (options.id) await this._service.delete(options.id, this.token);
    }

    public async update(options: DepartmentOptions): Promise<Department | Department[] | null> {
        return options.item?.id
            ? await this._service.update(options.item.id, options.item, this.token)
            : null;
    }

    public async add(options: DepartmentOptions): Promise<Department | Department[] | null> {
        return options.item ? await this._service.add(options.item, this.token) : null;
    }

    public async import(options: DepartmentOptions): Promise<ImportResult<Department> | undefined> {
        if (options.file) return await this._service.import(this.token, options.file);
    }

    public async export(options: DepartmentOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "");
    }
}
